import * as R from 'ramda'
import {
  type Nil,
  type Question,
  QuestionAnswerTypes,
} from '@pbt/pbt-ui-components'
import { getConstantName } from '@pbt/pbt-ui-components/src/utils'

import type { AnswerInputType } from '~/api/graphql/generated/types'

export const getAnswerTypeFlags = (
  value: string,
  AnswerInputTypes: AnswerInputType[],
) => {
  const answerType = getConstantName(value, AnswerInputTypes)
  const isMultiChoiceType = answerType === QuestionAnswerTypes.MULTIPLE_CHOICE
  const isCheckboxesType = answerType === QuestionAnswerTypes.CHECKBOXES
  const isQuantitySelectorType =
    answerType === QuestionAnswerTypes.QUANTITY_SELECTOR
  const isMultipleSelectionType = isMultiChoiceType || isCheckboxesType

  return {
    answerType,
    isMultiChoiceType,
    isCheckboxesType,
    isQuantitySelectorType,
    isMultipleSelectionType,
  }
}

export const validateFollowUpQuestion = (
  question: Nil | Partial<Question>,
  AnswerInputTypes: AnswerInputType[],
) => {
  if (question && question?.answerInputTypeId) {
    const { isMultipleSelectionType } = getAnswerTypeFlags(
      question.answerInputTypeId,
      AnswerInputTypes,
    )
    if (isMultipleSelectionType) {
      const isNilOrEmpty = R.either(R.isNil, R.isEmpty)
      const answers = question.answers?.filter(
        (followUpAnswer) =>
          !isNilOrEmpty(followUpAnswer) && !isNilOrEmpty(followUpAnswer.text),
      )

      return { ...question, answers }
    }
  }

  return question
}
